////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const languagesManager = {
	getLanguages: (
		filters = {},
		queryParams = { page: '0', size: '250', sort: 'enabled', nameDir: 'desc', sort_2: 'labelEnglish', nameDir_2: 'asc' }
	) => ({
		type: ActionsTypes.GET_LANGUAGES,
		payload: {
			filters,
			queryParams,
		},
	}),
	getLanguagesSuccess: (data) => ({
		type: ActionsTypes.GET_LANGUAGES_SUCCESS,
		payload: {
			data,
		},
	}),
	getLanguagesFailure: (error) => ({
		type: ActionsTypes.GET_LANGUAGES_FAILURE,
		payload: {
			error,
		},
	}),

	putLanguageEnabling: (id, enabled) => ({
		type: ActionsTypes.PUT_LANGUAGE_ENABLING,
		payload: {
			id,
			enabled,
		},
	}),
	putLanguageEnablingSuccess: (data) => ({
		type: ActionsTypes.PUT_LANGUAGE_ENABLING_SUCCESS,
		payload: {
			data,
		},
	}),
	putLanguageEnablingFailure: (error) => ({
		type: ActionsTypes.PUT_LANGUAGE_ENABLING_FAILURE,
		payload: {
			error,
		},
	}),

	resetDataLanguagesManager: () => ({
		type: ActionsTypes.RESET_DATA_LANGUAGES_MANAGER,
	}),
	getLanguageDetail: (idLanguage) => ({
		type: ActionsTypes.GET_LANGUAGE_DETAIL,
		payload: { idLanguage },
	}),
	getLanguageDetailSuccess: (data) => ({
		type: ActionsTypes.GET_LANGUAGE_DETAIL_SUCCESS,
		payload: {
			data,
		},
	}),
	getLanguageDetailFailure: (error) => ({
		type: ActionsTypes.GET_LANGUAGE_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),
	postCreateLanguageDetail: (data) => ({
		type: ActionsTypes.POST_CREATE_LANGUAGE_DETAIL,
		payload: {
			data,
		},
	}),
	postCreateLanguageDetailSuccess: (data) => ({
		type: ActionsTypes.POST_CREATE_LANGUAGE_DETAIL_SUCCESS,
		payload: { data },
	}),
	postCreateLanguageDetailFailure: (error) => ({
		type: ActionsTypes.POST_CREATE_LANGUAGE_DETAIL_FAILURE,
		payload: { error },
	}),
	postUpdateLanguageDetail: (data, idLanguage) => ({
		type: ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL,
		payload: {
			data,
			idLanguage,
		},
	}),
	postUpdateLanguageDetailSuccess: (data) => ({
		type: ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL_SUCCESS,
		payload: { data },
	}),
	postUpdateLanguageDetailFailure: (error) => ({
		type: ActionsTypes.POST_UPDATE_LANGUAGE_DETAIL_FAILURE,
		payload: { error },
	}),
	resetDataLanguageDetail: () => ({
		type: ActionsTypes.RESET_DATA_LANGUAGE_DETAIL,
	}),
}

export default languagesManager
